
import { inject, Injectable } from "@angular/core";
import { ApiService } from "@tylertech/core-module";
import { ICodeAndDescription, ILookupService, LookupCriteria } from "@tylertech/tyler-api-types";

/**
 * ItemCommodityCodeLookupService is a generated service implementation. Any edits will be overridden!
 */
@Injectable()
export class ItemCommodityCodeLookupService {
    private readonly $apiService = inject(ApiService);
    
    Lookup(pCriteria: LookupCriteria): Promise<ICodeAndDescription[]> {
        return this.$apiService.sendAuth("IItemCommodityCodeLookupService/Lookup", pCriteria);
    }
}
